import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TAddLikeAppendSucceed, EAddLikeActionType, IAddLikeSucceedParams } from './types';

export const addLikeSucceed: (data: IAddLikeSucceedParams) => TAddLikeAppendSucceed = actionGenerator<
  EAddLikeActionType.Succeed,
  IAddLikeSucceedParams
>(EAddLikeActionType.Succeed);
